<template>
    <div class="bg-white">
        <nav class="sub-menu border-b border-secondary">
            <router-link
                class="sub-menu-item"
                :to="{ name: 'GroupAdminGroups' }"
                @click.prevent.stop="gotoRoute({ name: 'GroupAdminGroups' })"
            >
                <IconOrg class="w-6 h-6 mr-2" />
                {{ $t("Groups") }}</router-link
            >
            <router-link
                class="sub-menu-item"
                :to="{ name: 'GroupAdminReports' }"
                @click.prevent="gotoRoute({ name: 'GroupAdminReports' })"
            >
                <IconReport class="w-6 h-6 mr-2" />
                Reports</router-link
            >
            <router-link
                v-if="currentGroup && currentGroup.id"
                class="sub-menu-item"
                :to="{
                    name: 'GroupAdminGroupOrderLicences',
                    params: { groupId: currentGroup.id }
                }"
                @click.prevent="
                    gotoRoute({ name: 'GroupAdminGroupOrderLicences', params: { groupId: currentGroup.id } })
                "
            >
                <IconLicence class="w-6 h-6 mr-2" />
                Order Licences</router-link
            >
        </nav>
    </div>
</template>
<script>
export default {
    computed: {
        currentGroup() {
            if (this.$store.state.admin.currentGroup && this.$store.state.admin.currentGroup.id) {
                return this.$store.state.admin.currentGroup;
            }

            return null;
        }
    },
    methods: {
        gotoRoute(route) {
            this.$router.push(route);
            this.$store.commit("closeMobileMenu");
        }
    }
};
</script>

<style lang="postcss" scoped>
.sub-menu {
    @apply bg-secondary bg-opacity-25  px-0 sm:px-12 text-dark-grey text-sm flex flex-row flex-wrap items-center;
}
.sub-menu-item {
    @apply text-xs sm:text-base py-1 sm:py-2 px-4 sm:px-8 
    flex flex-row justify-start items-center flex-none w-full sm:w-auto;
}
.sub-menu-item:hover {
    @apply bg-secondary bg-opacity-75 text-white transition duration-500;
}
.sub-menu-item.router-link-active {
    @apply bg-secondary text-white transition duration-500;
}
</style>